import { Helmet } from 'react-helmet-async';

// ----------------------------------------------------------------------

export const SITE_URL = 'https://hophop.com.tr';
export const SITE_NAME = 'Hophop';
export const DEFAULT_TITLE = 'Hophop | Çocuklu Aileler için Etkinlik ve Şehir Rehberi';
export const DEFAULT_DESCRIPTION =
  'Hophop, çocuklu aileler için şehir rehberi. Etkinlik, atölye, kurs ve mekanları keşfedin, kolayca rezervasyon yapın.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export type PageSeoProps = {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
};

function toPlainText(value?: string, max = 180) {
  if (!value) return '';

  const text = value
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (text.length <= max) return text;

  return `${text.slice(0, max - 1)}…`;
}

function toAbsoluteUrl(value?: string) {
  if (!value) return DEFAULT_OG_IMAGE;
  if (value.startsWith('http://') || value.startsWith('https://')) return value;

  return `${SITE_URL}${value.startsWith('/') ? '' : '/'}${value}`;
}

export function PageSeo({ title, description, image, url, type = 'website' }: PageSeoProps) {
  const pageTitle = title?.trim() || DEFAULT_TITLE;
  const pageDescription = toPlainText(description) || DEFAULT_DESCRIPTION;
  const pageImage = toAbsoluteUrl(image);
  const pageUrl = url || (typeof window !== 'undefined' ? window.location.href : SITE_URL);

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:alt" content={pageTitle} />
      <meta property="og:url" content={pageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
}
